import { Injectable } from '@angular/core';
import { ModalService } from './modal/modal.service';
import { SupportTicket, SupportTicketResponse } from '@models/support-ticket.interface';
import { SessionService } from '@shared/session.service';
import { SocketService } from '@shared/socket.service';

export enum SupportTicketFilter {
  None = 0,
  InProgress = 1,
  Unanswered = 2,
  Closed = 3,
}

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  tickets: SupportTicket[] = [];
  currentTicket: SupportTicket;
  currentTicketMessages: SupportTicketResponse[] = [];

  categories: { id: number; name: string }[] = [
    { id: 1, name: 'Jackpot' },
    { id: 2, name: 'Coinflip' },
    { id: 3, name: 'Case Battles' },
    { id: 4, name: 'Plinko' },
    { id: 6, name: 'Mines' },
    { id: 7, name: 'Towers' },
    { id: 8, name: 'King' },
    { id: 9, name: 'Trades' },
    { id: 10, name: 'Pricing' },
  ];

  constructor(private socketService: SocketService, private sessionService: SessionService, private modalService: ModalService) {}

  async getTickets(filter?: SupportTicketFilter) {
    if (this.sessionService.is_admin) {
      const res = await this.socketService.emit('admin_load_tickets', { type: filter ?? 0 });
      this.tickets = res;
    } else {
      const res = await this.socketService.emit('load_tickets');
      this.tickets = res;
    }
    return this.tickets;
  }

  async getUserTickets(steamid: string) {
    const res = await this.socketService.emit('load_tickets', { steamid });
    this.tickets = res;
  }

  async getTicket(id: number) {
    const [ticket, responses] = await this.socketService.emitArgs('load_ticket', { ticketid: id });
    this.currentTicket = ticket;
    this.currentTicketMessages = [
      { steamid: ticket.steamid, name: ticket.name, avatar: ticket.avatar, role: ticket.role, time: ticket.opened, response: ticket.description },
      ...responses,
    ];
    return this.currentTicket;
  }

  async respondToTicket(message: string) {
    await this.socketService.emit('ticket_respond', { ticketid: this.currentTicket.id, message });
    return true;
  }

  async closeTicket(ticketId?: number) {
    await this.socketService.emit('close_ticket', { ticketid: ticketId ?? this.currentTicket.id });
    return true;
  }

  async createTicket(category: number, title: string, associated: string, description: string) {
    await this.socketService.emit('create_ticket', { category, title, associated, description });
    return true;
  }

  getCategoryById(categoryId: number) {
    return this.categories.find((c) => c.id === categoryId);
  }
}
